import 'vxe-table-quantdata/lib/style.css'
import Vue from 'vue'
import XEUtils from 'xe-utils'
import httpManager from '../../util/common'
import TitleLabel from '../../entity/components/TitleLabel.vue'
import VXETable from 'vxe-table-quantdata'
import FilterBtn from '../components/FilterBtn.vue'
import { entityOaid } from '../../util/util'

Vue.use('vxe-table')
let vm = {
  name: 'RevenueBreakdown',
  data: () => {
    return {
      loading: false,
      page: {
        layouts: ['PrevPage', 'Number', 'NextPage'],
        currentPage: 1,
        pageSize: 10,
        total: 0,
        align: 'center',
        perfect: true,
        pagerCount: 3
      },
      options: [55,66,77],
      // 表格数据
      data: [],
      filterData: [],
      tableToolbar: {
        slots: {
          buttons: 'toolbar_buttons'
        }
      },
      year: null,
      label: null,
      product: null,
      standard_prod: null,
      order_col: null,
      asc_order: null,
      year_options: [],
      product_options: null,
      standardized_product_options: null,
      label_options: null,
      swhyString: '',
      citicsString: '',
      csinString: '',
      csrcString: '',
      isOnce: true,
      oaid: ''
    }
  },
  methods: {
    onFilter(value) {
      console.log(value);
    },
    timestampToTime(timestamp) {
      var date = new Date(timestamp);
      var Y = date.getFullYear();
      return Y;
    },
    pageChange({ currentPage, pageSize }) {
      this.page.currentPage = currentPage
      this.page.pageSize = pageSize
      this.getFilterRevenueBreakdownData()
    },
    getFilterRevenueBreakdownData() {
      this.filterData = this.data.filter((item, index) =>  (this.page.currentPage - 1) * this.page.pageSize <= index && index < this.page.currentPage * this.page.pageSize)
    },
    // 排序按钮事件
    sortChangeEvent({ column, property, order }){
      this.order_col = property
      this.asc_order= order
      if (!this.asc_order) {
        this.order_col = null
      }
      this.page.currentPage = 1
      this.page.pageSize = 10
      this.getRevenueBreakdownData()
    },
    cellClickEvent() {},
    headerCellClickEvent() {},
    washData(data, key) {
      let arr = []
      for (let i = 0; i < data.length; i++) {
        if (!arr.includes(data[i][key]) && data[i][key]) {
          arr.push(data[i][key])
        }
      }
      if (key === 'product_label') {
        let arr2 = arr.join('，').split('，')
        arr = []
        arr2.forEach(item => {
          if (!arr.includes(item)) {
            arr.push(item)
          }
        })
      }
      return arr
    },
    clearData() {
      this.year = null
      this.label = null
      this.product = null
      this.standard_prod = null
      this.order_col = null
      this.asc_order = null
      this.$refs.xTable_data.clearSort()
      this.getRevenueBreakdownData()
    },
    getGics(){
      let pathVars = new Map()
      pathVars.set("oaid", this.oaid)
      httpManager("entity_breakdown_info",null,null,null,pathVars)
        .then(res => {
          let industryMap = [
            {label: 'swhyString',value: '0080003',},
            {label: 'citicsString',value: '0080014',},
            {label: 'csinString',value: '0080008',},
            {label: 'csrcString',value: '0089001'}
          ]
          industryMap.forEach(label => {
            res.data.data.forEach(item => {
              if (label.value === item.industry) {
                this[label.label] = item.name.filter(value => value !== null).join('-')
              }
            })
          })
        })
        .catch(error => {
          console.log(error)
        })
    },
    compare(a, b) {
      // 将两个字符串转换为大写
      a = a.toUpperCase();
      b = b.toUpperCase();
      // 使用localeCompare()方法比较两个字符串
      return a.localeCompare(b, 'zh-Hans-CN', { sensitivity: 'accent' });
    },
    changeOaid () {
      let id = this.$route.params.oaid
      entityOaid.oaid(id).then(result => {
        this.oaid =result
        this.getRevenueBreakdownData()
        this.getGics()
      })
    },
    getRevenueBreakdownData() {
      this.page.currentPage = 1
      let params = new Map()
      params.set('all', true)
      params.set('oaid', this.oaid)
      if (this.year) {
        params.set('year', this.year)
      }
      if (this.label) {
        params.set('label', this.label)
      }
      if (this.product) {
        params.set('product', this.product)
      }
      if (this.standard_prod) {
        params.set('standard_prod', this.standard_prod)
      }
      if (this.order_col) {
        params.set('order_col', this.order_col)
      }
      if (this.asc_order) {
        params.set('asc_order', this.asc_order === 'asc' ? true : false)
      }
      httpManager('revenue_breakdown_info', params).then(res => {
        
        if (res.data.data === null) {
          this.filterData = []
        } 
        if (res.data.data) {
          this.data = res.data.data
          this.page.total = res.data.data.length
          this.filterData = this.data.filter((item, index) =>  (this.page.currentPage - 1) * this.page.pageSize <= index && index < this.page.currentPage * this.page.pageSize)
          if (this.isOnce) {
            this.year_options = this.washData(res.data.data, 'start_date').map(item => item = this.timestampToTime(item))
            this.product_options = this.washData(res.data.data, 'product_name')
            this.standardized_product_options = this.washData(res.data.data, 'standardized_product_name')
            this.label_options = this.washData(res.data.data, 'product_label')
            this.isOnce = false
          }
        }
      })
    }
  },
  computed: {
    locale () {
      return Cookies.get('locale') || 'zh'
    },
    product_label_options() {
      if(this.label_options) {
        return this.label_options.sort(this.compare).slice(0, 15)
      } else {
        return []
      }
    },
    product_name_options() {
      if (this.product_options) {
        return this.product_options.filter(item => !item.includes('其他') && !item.includes('平衡项目') && !item.includes('其它')).slice(0, 10)
      } else {
        return []
      }
    },
    tableColumn() {
      return [
        {title: 'i18n.common.ticker', field: 'ticker', className: 'click-cell-style'},
        {title: 'i18n.user_center.entity_name', field: 'full_name' },
        {title: 'i18n.supplychain.fil_year', field: 'start_date', sortable: true, formatter: ({cellValue}) => { return cellValue ? this.timestampToTime(cellValue) + '年': ''}},
        {title: 'i18n.supplychain.product', field: 'product_name'},
        {title: 'i18n.supplychain.standard_product', field: 'standardized_product_name'},
        {title: 'i18n.supplychain.concept_label', field: 'product_label'},
        {title: 'i18n.supplychain.revenue', field: 'product_revenue_avemethod', sortable: true, formatter: ({cellValue}) => { return cellValue ? `${XEUtils.commafy(XEUtils.toNumber(cellValue)/10000, {digits: 2})}` : ''}},
        {title: 'i18n.supplychain.revenue_proportion%', field: 'product_revenue_percentage_avemethod', sortable: true,  formatter: ({cellValue}) => { return cellValue ? `${XEUtils.commafy(XEUtils.toNumber(cellValue), {digits: 2})}` : ''}}
      ]
    }
  },
  created () {
    this.changeOaid()
  },
  watch: {
    year() {
      if (this.year === '') {
        this.year = null
      }
      this.getRevenueBreakdownData()
    },
    label() {
      if (this.label === '') {
        this.label = null
      }
      this.getRevenueBreakdownData()
    },
    product() {
      if (this.product === '') {
        this.product = null
      }
      this.getRevenueBreakdownData()
    },
    standard_prod() {
      if (this.standard_prod === '') {
        this.standard_prod = null
      }
      this.getRevenueBreakdownData()
    }
  },
  components: { TitleLabel, FilterBtn }
}

export default vm


// WEBPACK FOOTER //
// ./src/supplychain/js/RevenueBreakdown.js